<template>
    <div id="viewer-loading" ref="viewer-container" class="d-flex justify-content-center align-items-center">
        <img src="@/assets/img/loading/load-grayscale.gif" />
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#viewer-loading {
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: #151517;
    overflow: hidden;
    z-index: 100000000000;
    img {
        height: 20%;
        width: auto;
    }
}
</style>
